import { tabAccessControl } from "../../../_helpers/access-control";

let CrackingRunTabs = [
  {
    text: "Grower Ready",
    path: "/grower-ready",
    applicationFeatureCode: "CrackingRunGrowerReady",
  },
];

function GetIndexByTabName(tabName) {
  return tabAccessControl(CrackingRunTabs).findIndex((x) => x.text == tabName);
}

export { CrackingRunTabs, GetIndexByTabName };
